import React, { useCallback, useEffect, useRef, useState } from 'react';

import { useField } from '@unform/core';
import Select, { OptionTypeBase, Props as SelectProps } from 'react-select';

import InputError from '../InputError';
import { Container } from './styles';

interface IOptionType {
  [key: string]: any;
}

interface ISelectProps extends SelectProps<OptionTypeBase> {
  name: string;
  label: string;
  containerStyle?: {};
  containerClassName?: string;
  options: IOptionType[];
  required?: boolean;
}

const SelectWithLabel: React.FC<ISelectProps> = ({
  name,
  label,
  containerStyle = {},
  containerClassName,
  options,
  required = false,
  ...rest
}) => {
  const selectRef = useRef(null);

  const [isFocused, setIsFocused] = useState(false);
  const [groupOptions, setGroupOptions] = useState([]);

  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleSelectFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleSelectBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  useEffect(() => {
    setGroupOptions([
      { value: null, label: '- SELECIONE -', isDisabled: true },
      ...options,
    ]);
  }, [options]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,

      getValue: ref => ref.state.value,
      setValue: (ref, value) => {
        ref.select.setValue(value || null);
      },
      clearValue: ref => {
        ref.select.clearValue();
      },
    });
  }, [fieldName, registerField, rest.isMulti]);

  return (
    <Container
      style={containerStyle}
      isErrored={!!error}
      isFocused={isFocused}
      className={`select-with-label${
        containerClassName ? ` ${containerClassName}` : ''
      }`}
    >
      <label
        htmlFor={name}
        className={`${required ? 'required' : ''}
            }`}
      >
        {label}
      </label>
      <Select
        onBlur={handleSelectBlur}
        onFocus={handleSelectFocus}
        defaultValue={defaultValue || groupOptions[0]}
        ref={selectRef}
        classNamePrefix="react-select"
        options={groupOptions}
        // isSearchable={false}
        {...rest}
      />
      {error && <InputError title={error} />}
    </Container>
  );
};

export default SelectWithLabel;
